import { api } from "..";

export interface SetStepUpPasswordPayload {
  password: string;
}

export interface SetStepUpPasswordResponse {
  success: boolean;
}

export async function setStepUpPassword(
  payload: SetStepUpPasswordPayload
): Promise<SetStepUpPasswordResponse> {
  const res = await api.client.post("/auth-new/step-up-password", payload);
  return res.data;
}
